import { createLazyErrorReporter } from '@repo/observability/lazy'

// Lazy so `@sentry/core` stays out of the initial client graph. The client loader inits Sentry
// itself, so an error captured before the idle-time bootstrap in `instrumentation-client.ts` isn't
// flushed into an uninitialized SDK and dropped — `error.tsx` and `global-error.tsx` capture on the
// render path, which can run first. On the server the loader resolves in-process (Sentry inits
// eagerly via `instrumentation.ts`) and runs at module evaluation — see {@link createLazyErrorReporter}.
export const errorReporter = createLazyErrorReporter(
  () =>
    typeof window === 'undefined'
      ? import('@repo/observability/sentry').then(mod => mod.createSentryReporter())
      : import('./sentry.client').then(mod => {
          mod.initSentry()
          return mod.sentryReporter
        }),
  { eager: typeof window === 'undefined' }
)
